module.exports = __webpack_public_path__ + "media/images/icons/flags/RW-b052649fe0431ac68616a582bb037a38.svg";